/* Feb-2026 · Grandfather-pricing badge.
 *
 * Rendered on `MyBillingPanel`. Fetches `/subscriptions/me/price-lock`
 * once on mount and hides itself when the flag is off, when the user
 * has no active sub, or when there's no lock date yet.
 */
import React, { useEffect, useState } from 'react';
import { ShieldCheck } from 'lucide-react';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

export default function GrandfatherBadge() {
  const [data, setData] = useState(null);
  useEffect(() => {
    fetch(`${API}/subscriptions/me/price-lock`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then(setData)
      .catch(() => {});
  }, []);
  if (!data || !data.enabled || !data.active || !data.locked_until) return null;
  const dt = new Date(data.locked_until).toLocaleDateString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric',
  });
  return (
    <div
      className="my-3 flex items-start gap-2 rounded-md border border-amber-500/40 bg-amber-500/5 px-3 py-2.5 text-[12px]"
      data-testid="grandfather-badge"
    >
      <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
      <div className="min-w-0 flex-1">
        <div className="text-[12.5px] font-semibold text-amber-700">
          Your rate is locked until {dt}
        </div>
        <div className="text-[11px] text-muted-foreground">
          {data.price_usd
            ? <>You're paying <b className="font-mono-stat">${data.price_usd.toFixed(2)}</b>/{data.cadence || 'month'} — that price is guaranteed for the next {data.days_remaining ?? '—'} days regardless of pricing changes.</>
            : <>Your current subscription rate is guaranteed for {data.days_remaining ?? '—'} more days regardless of pricing changes.</>}
        </div>
      </div>
    </div>
  );
}
